import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const BLOGS = [
  { id: 1, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_1.png', day: '23', mon: 'JAN' },
  { id: 2, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_2.png', day: '28', mon: 'JAN' },
  { id: 3, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_3.png', day: '12', mon: 'FEB' },
  { id: 4, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_4.png', day: '07', mon: 'MAR' },
  { id: 5, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_5.png', day: '22', mon: 'APR' },
  { id: 6, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_6.png', day: '03', mon: 'MAY' },
  { id: 7, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_1.png', day: '14', mon: 'MAY' },
  { id: 8, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_2.png', day: '19', mon: 'JUN' },
  { id: 9, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_3.png', day: '08', mon: 'JUL' },
  { id: 10, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_4.png', day: '27', mon: 'AUG' },
  { id: 11, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_5.png', day: '02', mon: 'SEP' },
  { id: 12, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_6.png', day: '16', mon: 'OCT' },
  { id: 13, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_1.png', day: '11', mon: 'NOV' },
  { id: 14, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_2.png', day: '29', mon: 'NOV' },
  { id: 15, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_3.png', day: '05', mon: 'DEC' },
  { id: 16, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_4.png', day: '15', mon: 'DEC' },
  { id: 17, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_5.png', day: '20', mon: 'DEC' },
  { id: 18, title: 'Blog Title Heading 01', img: '/assets/imgs/Blogs/Inner Pages_Picture_Blog_6.png', day: '30', mon: 'DEC' },
];

const PER_PAGE = 6;
const brown = '#6c534e';
const white = '#fefefe';

const BlogCard = ({ post, title, excerpt, monthLabel, dayLabel }) => (
  <article className="group transition-all duration-300 hover:-translate-y-1">
    <div className="relative rounded-xl overflow-hidden shadow-sm transition-shadow duration-300 group-hover:shadow-xl">
      <img 
        src={post.img} 
        alt={post.title} 
        className="w-full h-56 md:h-64 lg:h-72 object-cover transition-transform duration-500 group-hover:scale-105" 
      />
      {/* overlay on hover */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
      {/* date badge - larger and positioned at bottom-left with margins */}
      <div className="absolute bottom-3 left-3 w-14 h-14 rounded-full flex flex-col items-center justify-center transition-transform duration-300 group-hover:-translate-y-1 group-hover:shadow" style={{ backgroundColor: brown }}>
        <span className="text-[11px] leading-none font-medium" style={{ color: white }}>{monthLabel}</span>
        <span className="text-sm font-bold leading-none" style={{ color: white }}>{dayLabel}</span>
      </div>
    </div>
    <div className="pt-4">
      <h3 className="text-[#151716] text-base md:text-lg font-bold transition-colors duration-300 group-hover:text-[#6c534e]">{title}</h3>
      <p className="text-[#474341] text-sm mt-2 mb-3">{excerpt}</p>
      {/* Very wide horizontal arrow */}
      <div className="flex">
        <svg width="48" height="16" viewBox="0 0 48 16" fill="none" stroke="#151716" strokeWidth="2.5" className="transition-transform duration-300 group-hover:translate-x-2">
          <path d="M2 8h40" />
          <path d="m36 2 6 6-6 6" />
        </svg>
      </div>
    </div>
  </article>
);

const Pager = ({ page, pages, onPage }) => {
  const items = useMemo(() => Array.from({ length: pages }, (_, i) => i + 1), [pages]);
  return (
    <div className="flex items-center justify-center gap-4 mt-10">
      {/* prev */}
      <button onClick={() => onPage(Math.max(1, page - 1))} className="w-11 h-11 rounded-full border border-[#cdbfb2] flex items-center justify-center text-[#151716]">
        &lt;
      </button>

      {items.map((n) => (
        <button
          key={n}
          onClick={() => onPage(n)}
          className={`w-11 h-11 rounded-full border border-[#cdbfb2] flex items-center justify-center text-sm font-medium ${
            n === page ? '' : ''
          }`}
          style={n === page ? { backgroundColor: brown, color: white } : { color: '#151716' }}
        >
          {String(n).padStart(2, '0')}
        </button>
      ))}

      {/* next */}
      <button onClick={() => onPage(Math.min(pages, page + 1))} className="w-11 h-11 rounded-full border border-[#cdbfb2] flex items-center justify-center text-[#151716]">
        &gt;
      </button>
    </div>
  );
};

const BlogSection = () => {
  const { t, i18n } = useTranslation('common');
  const [page, setPage] = useState(1);
  const pages = Math.ceil(BLOGS.length / PER_PAGE);
  const slice = useMemo(() => BLOGS.slice((page - 1) * PER_PAGE, page * PER_PAGE), [page]);

  // Localized titles/excerpts map for 12 languages (fallback if locale JSON lacks blog.*)
  const lng = (i18n.language || 'en').split('-')[0];
  const titleMap = {
    ar: 'عنوان المقال', ur: 'بلاگ کی سرخی', en: 'Blog Title Heading', fr: 'Titre de l’article',
    de: 'Blogtitel Überschrift', es: 'Encabezado del blog', pt: 'Título do artigo', ja: 'ブログ記事の見出し',
    hi: 'ब्लॉग शीर्षक हेडिंग', it: 'Titolo dell’articolo', ru: 'Заголовок записи', zh: '博客文章标题'
  };
  const excerptMap = {
    ar: 'هذا نص تمهيدي قصير يُظهر موجز المحتوى.', ur: 'یہ مختصر متن مواد کا خلاصہ دکھاتا ہے۔', en: 'This is a short excerpt for the blog post showing a brief summary of the content.',
    fr: 'Court extrait présentant un bref résumé du contenu.', de: 'Kurzer Auszug mit einer Zusammenfassung des Inhalts.', es: 'Un breve extracto que resume el contenido.', pt: 'Um breve excerto resumindo o conteúdo.',
    ja: '内容の要約を示す短い抜粋です。', hi: 'सामग्री के संक्षिप्त सारांश को दिखाने वाला छोटा अंश।', it: 'Un breve estratto che riassume il contenuto.', ru: 'Короткий отрывок с кратким содержанием.', zh: '展示内容简要摘要的短摘录。'
  };
  const titleFromRes = i18n.getResource(lng, 'common', 'blog.cardTitle');
  const excerptFromRes = i18n.getResource(lng, 'common', 'blog.excerpt');
  const cardTitle = (typeof titleFromRes === 'string' && titleFromRes) || titleMap[lng] || titleMap.en;
  const cardExcerpt = (typeof excerptFromRes === 'string' && excerptFromRes) || excerptMap[lng] || excerptMap.en;

  // Localize month/day using Intl
  const fmtMonth = new Intl.DateTimeFormat(lng, { month: 'short' });
  const fmtDay = new Intl.NumberFormat(lng, { minimumIntegerDigits: 2 });
  const monthIndex = { JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5, JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11 };

  return (
    <section className="bg-cream py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* grid 2 cols desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {slice.map((post) => {
            const date = new Date(2024, monthIndex[post.mon], Number(post.day));
            const monthLabel = fmtMonth.format(date);
            const dayLabel = fmtDay.format(Number(post.day));
            return (
              <BlogCard key={post.id} post={post} title={cardTitle} excerpt={cardExcerpt} monthLabel={monthLabel} dayLabel={dayLabel} />
            );
          })}
        </div>

        <Pager page={page} pages={pages} onPage={setPage} />
      </div>
    </section>
  );
};

export default BlogSection;
